import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TreeItem  {
    _originalTypeClassName = "zERP.BO.TreeItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TreeItem.translate = translateService;
}
this.Children = [];
this.ItemId = null;
this.ItemName = null;
this.IsOpen = false;
this.Subtitle = null;
this.TreeItemKey = null;
this._key = this.TreeItemKey = 0; 
}

static translate: TranslateService;
_key: any;
ItemId:any;
ItemName:any;
IsOpen:any;
Subtitle:any;
Children:any;
private _TreeItemKey:any;
get TreeItemKey(): any {
    return this._TreeItemKey;
  }
set TreeItemKey(value: any) {
    this._TreeItemKey = value;
    this._key = value;
  }
static setChildren = ($this, items) => {
                if (items == null) items = [];
                if ($this.Children == null) $this.Children = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Children.length > 0) {
                    Domain.TreeItem.removeChildren($this, $this.Children[0]);
                }

                Domain.TreeItem.addManyChildren($this, copyItems);
            }
static addManyChildren = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TreeItem.addChildren($this, items[i]);
                }
            }
static addChildren = ($this, item) => {
                if ($this.Children == null) $this.Children = [];
                if (item == null || $this.Children.indexOf(item) > -1) return;
                $this.Children.push(item);
}
static addRangeChildren = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TreeItem.addChildren($this, item));
            }
static removeChildren = ($this, item) => {
                if ($this == null || $this.Children == null || $this.Children.indexOf(item) === -1) return;
                var _index = $this.Children.indexOf(item);
                $this.Children.splice(_index, 1);
}
static clearChildren = ($this) => { $this.Children = null; }

static CreateCategory(cat: any): any{let tree = new Domain.TreeItem();
tree.ItemName = cat?.Name;
tree.Subtitle = cat?.Code;
tree.ItemId = cat?.AccountCategoryID;
for (let _ichild = 0; _ichild < (cat?.ChildAccountCategories == null ? 0 : cat?.ChildAccountCategories.length); _ichild++) {let child = cat?.ChildAccountCategories[_ichild];tree?.Children?.add(Domain.TreeItem.CreateCategory(child));}
return tree;
}
static GetNodeById(nodeId: any,nodesToSearch: any): any{for (let _iitem = 0; _iitem < (nodesToSearch == null ? 0 : nodesToSearch.length); _iitem++) {let item = nodesToSearch[_iitem];if ((CLMS.Framework.Number.Equal(() => item.ItemId, () => nodeId))) {return item;}if (item?.Children != null && CLMS.Framework.Number.GreaterThan(() => item.Children.length, () => 0)) {let foundNode = Domain.TreeItem.GetNodeById(nodeId, item?.Children);if ((foundNode != null)) {return foundNode;}}}
return null;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TreeItemKey == null || $this.TreeItemKey == 0;
            }


}